// Ülke arama kodları — telefon giriş ekranındaki seçici için.
//
// D-427 — liste ISO 3166-1'in tamamını kapsar ve **İngilizce ada göre alfabetiktir**.
// Önceden 69 ülke vardı ve başta Türkiye duruyordu; listede olmayan bir ülkedeki kullanıcı
// hiç kayıt olamıyordu. nosubject UK'de kurulan küresel bir üründür (LEGAL.md), bu yüzden
// ne kapsam bir pazarla sınırlıdır ne de sıralama bir ülkeyi öne alır.
//
// D-428 — arama kodlarının tamamı Google libphonenumber meta verisine karşı doğrulandı
// (ITU-T E.164 türevi, sektör standardı): 245 kaydın tamamı eşleşiyor, eksik yok.
// AC (Ascension) ve TA (Tristan da Cunha) ISO 3166-1'de istisnaen ayrılmış kodlardır;
// kendi arama kodları olduğu ve libphonenumber onları tanıdığı için kapsama dahildir.
//
// Görünen ad çalışma anında `country-names.ts` tarafından kullanıcının diline çevrilir;
// buradaki `name` yalnız İngilizce yedek ve arama anahtarıdır.
//
// NANP ülkeleri (US, CA, JM, DO…) aynı +1 kodunu paylaşır; kullanıcı alan koduyla birlikte
// yazdığı için bu doğrudur.
export type Country = { name: string; dial: string; flag: string; iso: string };

export const COUNTRIES: Country[] = [
  { name: 'Afghanistan', dial: '+93', flag: '🇦🇫', iso: 'AF' },
  { name: 'Åland Islands', dial: '+358', flag: '🇦🇽', iso: 'AX' },
  { name: 'Albania', dial: '+355', flag: '🇦🇱', iso: 'AL' },
  { name: 'Algeria', dial: '+213', flag: '🇩🇿', iso: 'DZ' },
  { name: 'American Samoa', dial: '+1', flag: '🇦🇸', iso: 'AS' },
  { name: 'Andorra', dial: '+376', flag: '🇦🇩', iso: 'AD' },
  { name: 'Angola', dial: '+244', flag: '🇦🇴', iso: 'AO' },
  { name: 'Anguilla', dial: '+1', flag: '🇦🇮', iso: 'AI' },
  { name: 'Antigua & Barbuda', dial: '+1', flag: '🇦🇬', iso: 'AG' },
  { name: 'Argentina', dial: '+54', flag: '🇦🇷', iso: 'AR' },
  { name: 'Armenia', dial: '+374', flag: '🇦🇲', iso: 'AM' },
  { name: 'Aruba', dial: '+297', flag: '🇦🇼', iso: 'AW' },
  { name: 'Ascension Island', dial: '+247', flag: '🇦🇨', iso: 'AC' },
  { name: 'Australia', dial: '+61', flag: '🇦🇺', iso: 'AU' },
  { name: 'Austria', dial: '+43', flag: '🇦🇹', iso: 'AT' },
  { name: 'Azerbaijan', dial: '+994', flag: '🇦🇿', iso: 'AZ' },
  { name: 'Bahamas', dial: '+1', flag: '🇧🇸', iso: 'BS' },
  { name: 'Bahrain', dial: '+973', flag: '🇧🇭', iso: 'BH' },
  { name: 'Bangladesh', dial: '+880', flag: '🇧🇩', iso: 'BD' },
  { name: 'Barbados', dial: '+1', flag: '🇧🇧', iso: 'BB' },
  { name: 'Belarus', dial: '+375', flag: '🇧🇾', iso: 'BY' },
  { name: 'Belgium', dial: '+32', flag: '🇧🇪', iso: 'BE' },
  { name: 'Belize', dial: '+501', flag: '🇧🇿', iso: 'BZ' },
  { name: 'Benin', dial: '+229', flag: '🇧🇯', iso: 'BJ' },
  { name: 'Bermuda', dial: '+1', flag: '🇧🇲', iso: 'BM' },
  { name: 'Bhutan', dial: '+975', flag: '🇧🇹', iso: 'BT' },
  { name: 'Bolivia', dial: '+591', flag: '🇧🇴', iso: 'BO' },
  { name: 'Bosnia & Herzegovina', dial: '+387', flag: '🇧🇦', iso: 'BA' },
  { name: 'Botswana', dial: '+267', flag: '🇧🇼', iso: 'BW' },
  { name: 'Brazil', dial: '+55', flag: '🇧🇷', iso: 'BR' },
  { name: 'British Indian Ocean Territory', dial: '+246', flag: '🇮🇴', iso: 'IO' },
  { name: 'British Virgin Islands', dial: '+1', flag: '🇻🇬', iso: 'VG' },
  { name: 'Brunei', dial: '+673', flag: '🇧🇳', iso: 'BN' },
  { name: 'Bulgaria', dial: '+359', flag: '🇧🇬', iso: 'BG' },
  { name: 'Burkina Faso', dial: '+226', flag: '🇧🇫', iso: 'BF' },
  { name: 'Burundi', dial: '+257', flag: '🇧🇮', iso: 'BI' },
  { name: 'Cambodia', dial: '+855', flag: '🇰🇭', iso: 'KH' },
  { name: 'Cameroon', dial: '+237', flag: '🇨🇲', iso: 'CM' },
  { name: 'Canada', dial: '+1', flag: '🇨🇦', iso: 'CA' },
  { name: 'Cape Verde', dial: '+238', flag: '🇨🇻', iso: 'CV' },
  { name: 'Caribbean Netherlands', dial: '+599', flag: '🇧🇶', iso: 'BQ' },
  { name: 'Cayman Islands', dial: '+1', flag: '🇰🇾', iso: 'KY' },
  { name: 'Central African Republic', dial: '+236', flag: '🇨🇫', iso: 'CF' },
  { name: 'Chad', dial: '+235', flag: '🇹🇩', iso: 'TD' },
  { name: 'Chile', dial: '+56', flag: '🇨🇱', iso: 'CL' },
  { name: 'China', dial: '+86', flag: '🇨🇳', iso: 'CN' },
  { name: 'Christmas Island', dial: '+61', flag: '🇨🇽', iso: 'CX' },
  { name: 'Cocos (Keeling) Islands', dial: '+61', flag: '🇨🇨', iso: 'CC' },
  { name: 'Colombia', dial: '+57', flag: '🇨🇴', iso: 'CO' },
  { name: 'Comoros', dial: '+269', flag: '🇰🇲', iso: 'KM' },
  { name: 'Congo - Brazzaville', dial: '+242', flag: '🇨🇬', iso: 'CG' },
  { name: 'Congo - Kinshasa', dial: '+243', flag: '🇨🇩', iso: 'CD' },
  { name: 'Cook Islands', dial: '+682', flag: '🇨🇰', iso: 'CK' },
  { name: 'Costa Rica', dial: '+506', flag: '🇨🇷', iso: 'CR' },
  { name: 'Côte d’Ivoire', dial: '+225', flag: '🇨🇮', iso: 'CI' },
  { name: 'Croatia', dial: '+385', flag: '🇭🇷', iso: 'HR' },
  { name: 'Cuba', dial: '+53', flag: '🇨🇺', iso: 'CU' },
  { name: 'Curaçao', dial: '+599', flag: '🇨🇼', iso: 'CW' },
  { name: 'Cyprus', dial: '+357', flag: '🇨🇾', iso: 'CY' },
  { name: 'Czechia', dial: '+420', flag: '🇨🇿', iso: 'CZ' },
  { name: 'Denmark', dial: '+45', flag: '🇩🇰', iso: 'DK' },
  { name: 'Djibouti', dial: '+253', flag: '🇩🇯', iso: 'DJ' },
  { name: 'Dominica', dial: '+1', flag: '🇩🇲', iso: 'DM' },
  { name: 'Dominican Republic', dial: '+1', flag: '🇩🇴', iso: 'DO' },
  { name: 'Ecuador', dial: '+593', flag: '🇪🇨', iso: 'EC' },
  { name: 'Egypt', dial: '+20', flag: '🇪🇬', iso: 'EG' },
  { name: 'El Salvador', dial: '+503', flag: '🇸🇻', iso: 'SV' },
  { name: 'Equatorial Guinea', dial: '+240', flag: '🇬🇶', iso: 'GQ' },
  { name: 'Eritrea', dial: '+291', flag: '🇪🇷', iso: 'ER' },
  { name: 'Estonia', dial: '+372', flag: '🇪🇪', iso: 'EE' },
  { name: 'Eswatini', dial: '+268', flag: '🇸🇿', iso: 'SZ' },
  { name: 'Ethiopia', dial: '+251', flag: '🇪🇹', iso: 'ET' },
  { name: 'Falkland Islands', dial: '+500', flag: '🇫🇰', iso: 'FK' },
  { name: 'Faroe Islands', dial: '+298', flag: '🇫🇴', iso: 'FO' },
  { name: 'Fiji', dial: '+679', flag: '🇫🇯', iso: 'FJ' },
  { name: 'Finland', dial: '+358', flag: '🇫🇮', iso: 'FI' },
  { name: 'France', dial: '+33', flag: '🇫🇷', iso: 'FR' },
  { name: 'French Guiana', dial: '+594', flag: '🇬🇫', iso: 'GF' },
  { name: 'French Polynesia', dial: '+689', flag: '🇵🇫', iso: 'PF' },
  { name: 'Gabon', dial: '+241', flag: '🇬🇦', iso: 'GA' },
  { name: 'Gambia', dial: '+220', flag: '🇬🇲', iso: 'GM' },
  { name: 'Georgia', dial: '+995', flag: '🇬🇪', iso: 'GE' },
  { name: 'Germany', dial: '+49', flag: '🇩🇪', iso: 'DE' },
  { name: 'Ghana', dial: '+233', flag: '🇬🇭', iso: 'GH' },
  { name: 'Gibraltar', dial: '+350', flag: '🇬🇮', iso: 'GI' },
  { name: 'Greece', dial: '+30', flag: '🇬🇷', iso: 'GR' },
  { name: 'Greenland', dial: '+299', flag: '🇬🇱', iso: 'GL' },
  { name: 'Grenada', dial: '+1', flag: '🇬🇩', iso: 'GD' },
  { name: 'Guadeloupe', dial: '+590', flag: '🇬🇵', iso: 'GP' },
  { name: 'Guam', dial: '+1', flag: '🇬🇺', iso: 'GU' },
  { name: 'Guatemala', dial: '+502', flag: '🇬🇹', iso: 'GT' },
  { name: 'Guernsey', dial: '+44', flag: '🇬🇬', iso: 'GG' },
  { name: 'Guinea', dial: '+224', flag: '🇬🇳', iso: 'GN' },
  { name: 'Guinea-Bissau', dial: '+245', flag: '🇬🇼', iso: 'GW' },
  { name: 'Guyana', dial: '+592', flag: '🇬🇾', iso: 'GY' },
  { name: 'Haiti', dial: '+509', flag: '🇭🇹', iso: 'HT' },
  { name: 'Honduras', dial: '+504', flag: '🇭🇳', iso: 'HN' },
  { name: 'Hong Kong SAR China', dial: '+852', flag: '🇭🇰', iso: 'HK' },
  { name: 'Hungary', dial: '+36', flag: '🇭🇺', iso: 'HU' },
  { name: 'Iceland', dial: '+354', flag: '🇮🇸', iso: 'IS' },
  { name: 'India', dial: '+91', flag: '🇮🇳', iso: 'IN' },
  { name: 'Indonesia', dial: '+62', flag: '🇮🇩', iso: 'ID' },
  { name: 'Iran', dial: '+98', flag: '🇮🇷', iso: 'IR' },
  { name: 'Iraq', dial: '+964', flag: '🇮🇶', iso: 'IQ' },
  { name: 'Ireland', dial: '+353', flag: '🇮🇪', iso: 'IE' },
  { name: 'Isle of Man', dial: '+44', flag: '🇮🇲', iso: 'IM' },
  { name: 'Israel', dial: '+972', flag: '🇮🇱', iso: 'IL' },
  { name: 'Italy', dial: '+39', flag: '🇮🇹', iso: 'IT' },
  { name: 'Jamaica', dial: '+1', flag: '🇯🇲', iso: 'JM' },
  { name: 'Japan', dial: '+81', flag: '🇯🇵', iso: 'JP' },
  { name: 'Jersey', dial: '+44', flag: '🇯🇪', iso: 'JE' },
  { name: 'Jordan', dial: '+962', flag: '🇯🇴', iso: 'JO' },
  { name: 'Kazakhstan', dial: '+7', flag: '🇰🇿', iso: 'KZ' },
  { name: 'Kenya', dial: '+254', flag: '🇰🇪', iso: 'KE' },
  { name: 'Kiribati', dial: '+686', flag: '🇰🇮', iso: 'KI' },
  { name: 'Kosovo', dial: '+383', flag: '🇽🇰', iso: 'XK' },
  { name: 'Kuwait', dial: '+965', flag: '🇰🇼', iso: 'KW' },
  { name: 'Kyrgyzstan', dial: '+996', flag: '🇰🇬', iso: 'KG' },
  { name: 'Laos', dial: '+856', flag: '🇱🇦', iso: 'LA' },
  { name: 'Latvia', dial: '+371', flag: '🇱🇻', iso: 'LV' },
  { name: 'Lebanon', dial: '+961', flag: '🇱🇧', iso: 'LB' },
  { name: 'Lesotho', dial: '+266', flag: '🇱🇸', iso: 'LS' },
  { name: 'Liberia', dial: '+231', flag: '🇱🇷', iso: 'LR' },
  { name: 'Libya', dial: '+218', flag: '🇱🇾', iso: 'LY' },
  { name: 'Liechtenstein', dial: '+423', flag: '🇱🇮', iso: 'LI' },
  { name: 'Lithuania', dial: '+370', flag: '🇱🇹', iso: 'LT' },
  { name: 'Luxembourg', dial: '+352', flag: '🇱🇺', iso: 'LU' },
  { name: 'Macao SAR China', dial: '+853', flag: '🇲🇴', iso: 'MO' },
  { name: 'Madagascar', dial: '+261', flag: '🇲🇬', iso: 'MG' },
  { name: 'Malawi', dial: '+265', flag: '🇲🇼', iso: 'MW' },
  { name: 'Malaysia', dial: '+60', flag: '🇲🇾', iso: 'MY' },
  { name: 'Maldives', dial: '+960', flag: '🇲🇻', iso: 'MV' },
  { name: 'Mali', dial: '+223', flag: '🇲🇱', iso: 'ML' },
  { name: 'Malta', dial: '+356', flag: '🇲🇹', iso: 'MT' },
  { name: 'Marshall Islands', dial: '+692', flag: '🇲🇭', iso: 'MH' },
  { name: 'Martinique', dial: '+596', flag: '🇲🇶', iso: 'MQ' },
  { name: 'Mauritania', dial: '+222', flag: '🇲🇷', iso: 'MR' },
  { name: 'Mauritius', dial: '+230', flag: '🇲🇺', iso: 'MU' },
  { name: 'Mayotte', dial: '+262', flag: '🇾🇹', iso: 'YT' },
  { name: 'Mexico', dial: '+52', flag: '🇲🇽', iso: 'MX' },
  { name: 'Micronesia', dial: '+691', flag: '🇫🇲', iso: 'FM' },
  { name: 'Moldova', dial: '+373', flag: '🇲🇩', iso: 'MD' },
  { name: 'Monaco', dial: '+377', flag: '🇲🇨', iso: 'MC' },
  { name: 'Mongolia', dial: '+976', flag: '🇲🇳', iso: 'MN' },
  { name: 'Montenegro', dial: '+382', flag: '🇲🇪', iso: 'ME' },
  { name: 'Montserrat', dial: '+1', flag: '🇲🇸', iso: 'MS' },
  { name: 'Morocco', dial: '+212', flag: '🇲🇦', iso: 'MA' },
  { name: 'Mozambique', dial: '+258', flag: '🇲🇿', iso: 'MZ' },
  { name: 'Myanmar (Burma)', dial: '+95', flag: '🇲🇲', iso: 'MM' },
  { name: 'Namibia', dial: '+264', flag: '🇳🇦', iso: 'NA' },
  { name: 'Nauru', dial: '+674', flag: '🇳🇷', iso: 'NR' },
  { name: 'Nepal', dial: '+977', flag: '🇳🇵', iso: 'NP' },
  { name: 'Netherlands', dial: '+31', flag: '🇳🇱', iso: 'NL' },
  { name: 'New Caledonia', dial: '+687', flag: '🇳🇨', iso: 'NC' },
  { name: 'New Zealand', dial: '+64', flag: '🇳🇿', iso: 'NZ' },
  { name: 'Nicaragua', dial: '+505', flag: '🇳🇮', iso: 'NI' },
  { name: 'Niger', dial: '+227', flag: '🇳🇪', iso: 'NE' },
  { name: 'Nigeria', dial: '+234', flag: '🇳🇬', iso: 'NG' },
  { name: 'Niue', dial: '+683', flag: '🇳🇺', iso: 'NU' },
  { name: 'Norfolk Island', dial: '+672', flag: '🇳🇫', iso: 'NF' },
  { name: 'North Korea', dial: '+850', flag: '🇰🇵', iso: 'KP' },
  { name: 'North Macedonia', dial: '+389', flag: '🇲🇰', iso: 'MK' },
  { name: 'Northern Mariana Islands', dial: '+1', flag: '🇲🇵', iso: 'MP' },
  { name: 'Norway', dial: '+47', flag: '🇳🇴', iso: 'NO' },
  { name: 'Oman', dial: '+968', flag: '🇴🇲', iso: 'OM' },
  { name: 'Pakistan', dial: '+92', flag: '🇵🇰', iso: 'PK' },
  { name: 'Palau', dial: '+680', flag: '🇵🇼', iso: 'PW' },
  { name: 'Palestinian Territories', dial: '+970', flag: '🇵🇸', iso: 'PS' },
  { name: 'Panama', dial: '+507', flag: '🇵🇦', iso: 'PA' },
  { name: 'Papua New Guinea', dial: '+675', flag: '🇵🇬', iso: 'PG' },
  { name: 'Paraguay', dial: '+595', flag: '🇵🇾', iso: 'PY' },
  { name: 'Peru', dial: '+51', flag: '🇵🇪', iso: 'PE' },
  { name: 'Philippines', dial: '+63', flag: '🇵🇭', iso: 'PH' },
  { name: 'Poland', dial: '+48', flag: '🇵🇱', iso: 'PL' },
  { name: 'Portugal', dial: '+351', flag: '🇵🇹', iso: 'PT' },
  { name: 'Puerto Rico', dial: '+1', flag: '🇵🇷', iso: 'PR' },
  { name: 'Qatar', dial: '+974', flag: '🇶🇦', iso: 'QA' },
  { name: 'Réunion', dial: '+262', flag: '🇷🇪', iso: 'RE' },
  { name: 'Romania', dial: '+40', flag: '🇷🇴', iso: 'RO' },
  { name: 'Russia', dial: '+7', flag: '🇷🇺', iso: 'RU' },
  { name: 'Rwanda', dial: '+250', flag: '🇷🇼', iso: 'RW' },
  { name: 'Samoa', dial: '+685', flag: '🇼🇸', iso: 'WS' },
  { name: 'San Marino', dial: '+378', flag: '🇸🇲', iso: 'SM' },
  { name: 'São Tomé & Príncipe', dial: '+239', flag: '🇸🇹', iso: 'ST' },
  { name: 'Saudi Arabia', dial: '+966', flag: '🇸🇦', iso: 'SA' },
  { name: 'Senegal', dial: '+221', flag: '🇸🇳', iso: 'SN' },
  { name: 'Serbia', dial: '+381', flag: '🇷🇸', iso: 'RS' },
  { name: 'Seychelles', dial: '+248', flag: '🇸🇨', iso: 'SC' },
  { name: 'Sierra Leone', dial: '+232', flag: '🇸🇱', iso: 'SL' },
  { name: 'Singapore', dial: '+65', flag: '🇸🇬', iso: 'SG' },
  { name: 'Sint Maarten', dial: '+1', flag: '🇸🇽', iso: 'SX' },
  { name: 'Slovakia', dial: '+421', flag: '🇸🇰', iso: 'SK' },
  { name: 'Slovenia', dial: '+386', flag: '🇸🇮', iso: 'SI' },
  { name: 'Solomon Islands', dial: '+677', flag: '🇸🇧', iso: 'SB' },
  { name: 'Somalia', dial: '+252', flag: '🇸🇴', iso: 'SO' },
  { name: 'South Africa', dial: '+27', flag: '🇿🇦', iso: 'ZA' },
  { name: 'South Korea', dial: '+82', flag: '🇰🇷', iso: 'KR' },
  { name: 'South Sudan', dial: '+211', flag: '🇸🇸', iso: 'SS' },
  { name: 'Spain', dial: '+34', flag: '🇪🇸', iso: 'ES' },
  { name: 'Sri Lanka', dial: '+94', flag: '🇱🇰', iso: 'LK' },
  { name: 'St. Barthélemy', dial: '+590', flag: '🇧🇱', iso: 'BL' },
  { name: 'St. Helena', dial: '+290', flag: '🇸🇭', iso: 'SH' },
  { name: 'St. Kitts & Nevis', dial: '+1', flag: '🇰🇳', iso: 'KN' },
  { name: 'St. Lucia', dial: '+1', flag: '🇱🇨', iso: 'LC' },
  { name: 'St. Martin', dial: '+590', flag: '🇲🇫', iso: 'MF' },
  { name: 'St. Pierre & Miquelon', dial: '+508', flag: '🇵🇲', iso: 'PM' },
  { name: 'St. Vincent & Grenadines', dial: '+1', flag: '🇻🇨', iso: 'VC' },
  { name: 'Sudan', dial: '+249', flag: '🇸🇩', iso: 'SD' },
  { name: 'Suriname', dial: '+597', flag: '🇸🇷', iso: 'SR' },
  { name: 'Svalbard & Jan Mayen', dial: '+47', flag: '🇸🇯', iso: 'SJ' },
  { name: 'Sweden', dial: '+46', flag: '🇸🇪', iso: 'SE' },
  { name: 'Switzerland', dial: '+41', flag: '🇨🇭', iso: 'CH' },
  { name: 'Syria', dial: '+963', flag: '🇸🇾', iso: 'SY' },
  { name: 'Taiwan', dial: '+886', flag: '🇹🇼', iso: 'TW' },
  { name: 'Tajikistan', dial: '+992', flag: '🇹🇯', iso: 'TJ' },
  { name: 'Tanzania', dial: '+255', flag: '🇹🇿', iso: 'TZ' },
  { name: 'Thailand', dial: '+66', flag: '🇹🇭', iso: 'TH' },
  { name: 'Timor-Leste', dial: '+670', flag: '🇹🇱', iso: 'TL' },
  { name: 'Togo', dial: '+228', flag: '🇹🇬', iso: 'TG' },
  { name: 'Tokelau', dial: '+690', flag: '🇹🇰', iso: 'TK' },
  { name: 'Tonga', dial: '+676', flag: '🇹🇴', iso: 'TO' },
  { name: 'Trinidad & Tobago', dial: '+1', flag: '🇹🇹', iso: 'TT' },
  { name: 'Tristan da Cunha', dial: '+290', flag: '🇹🇦', iso: 'TA' },
  { name: 'Tunisia', dial: '+216', flag: '🇹🇳', iso: 'TN' },
  { name: 'Türkiye', dial: '+90', flag: '🇹🇷', iso: 'TR' },
  { name: 'Turkmenistan', dial: '+993', flag: '🇹🇲', iso: 'TM' },
  { name: 'Turks & Caicos Islands', dial: '+1', flag: '🇹🇨', iso: 'TC' },
  { name: 'Tuvalu', dial: '+688', flag: '🇹🇻', iso: 'TV' },
  { name: 'U.S. Virgin Islands', dial: '+1', flag: '🇻🇮', iso: 'VI' },
  { name: 'Uganda', dial: '+256', flag: '🇺🇬', iso: 'UG' },
  { name: 'Ukraine', dial: '+380', flag: '🇺🇦', iso: 'UA' },
  { name: 'United Arab Emirates', dial: '+971', flag: '🇦🇪', iso: 'AE' },
  { name: 'United Kingdom', dial: '+44', flag: '🇬🇧', iso: 'GB' },
  { name: 'United States', dial: '+1', flag: '🇺🇸', iso: 'US' },
  { name: 'Uruguay', dial: '+598', flag: '🇺🇾', iso: 'UY' },
  { name: 'Uzbekistan', dial: '+998', flag: '🇺🇿', iso: 'UZ' },
  { name: 'Vanuatu', dial: '+678', flag: '🇻🇺', iso: 'VU' },
  { name: 'Vatican City', dial: '+39', flag: '🇻🇦', iso: 'VA' },
  { name: 'Venezuela', dial: '+58', flag: '🇻🇪', iso: 'VE' },
  { name: 'Vietnam', dial: '+84', flag: '🇻🇳', iso: 'VN' },
  { name: 'Wallis & Futuna', dial: '+681', flag: '🇼🇫', iso: 'WF' },
  { name: 'Western Sahara', dial: '+212', flag: '🇪🇭', iso: 'EH' },
  { name: 'Yemen', dial: '+967', flag: '🇾🇪', iso: 'YE' },
  { name: 'Zambia', dial: '+260', flag: '🇿🇲', iso: 'ZM' },
  { name: 'Zimbabwe', dial: '+263', flag: '🇿🇼', iso: 'ZW' },
];
